import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class SeasonApiClient extends AdvancedApiClient {

    static entityType = "Season"

    constructor(token, id) {
        super();

        this.setEntityType(SeasonApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/season/{id}")
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/season");
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}